// Mixpanel Configuration
const MIXPANEL_CONFIG = {
  development: { 
    token: '6063e48d67cefd36bcf8dc0acbb8cd6a', 
    debug: true, 
    track_pageview: false, 
    persistence: 'localStorage',
    api_host: 'https://api-eu.mixpanel.com',  
    record_sessions_percent: 100,
    // Session Recording: unmask non-input text globally; keep inputs masked by default
    record_mask_text_selector: '',
    // Allow media in session replay
    record_block_media: false,
    // Capture canvas (if used for rendering)
    record_canvas: true
  },
  qa: { 
    token: '6063e48d67cefd36bcf8dc0acbb8cd6a', 
    debug: true, 
    track_pageview: false, 
    persistence: 'localStorage',
    api_host: 'https://api-eu.mixpanel.com',
    record_sessions_percent: 100,
    record_mask_text_selector: '',
    record_block_media: false,
    record_canvas: true
  },
  production: { 
    token: '6063e48d67cefd36bcf8dc0acbb8cd6a', 
    debug: false, 
    track_pageview: false, 
    persistence: 'localStorage',
    api_host: 'https://api-eu.mixpanel.com',
    record_sessions_percent: 100,
    record_mask_text_selector: '',
    record_block_media: false,
    record_canvas: true
  }
};

// Get current environment
const getCurrentEnv = () => {
  if (typeof window !== 'undefined') {
    const hostname = window.location.hostname;
    if (hostname.includes('api.dev.app.pukaarai.com')) {
      return 'development';
    } else if (hostname.includes('qa') || hostname.includes('pukaar-fe-app-dev')) {
      return 'qa';
    } else if (hostname.includes('staging')) {
      return 'staging';
    } else {
      return 'production';
    }
  }
  return 'development';
};

export const MIXPANEL_TOKEN = MIXPANEL_CONFIG[getCurrentEnv()].token;
export const MIXPANEL_DEBUG = MIXPANEL_CONFIG[getCurrentEnv()].debug;
export const MIXPANEL_CONFIG_OPTIONS = MIXPANEL_CONFIG[getCurrentEnv()];
